import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=6eb188f3&scoped=true"
var script = {}
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=6eb188f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb188f3",
  null
  
)

export default component.exports